"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SocialLink;
var _react = _interopRequireDefault(require("react"));
var _Footer = require("./Footer.style");
var _SocialInstagram = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/53-Logos/03-Photos-Images/SocialInstagram"));
var _SocialMediaFacebook = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/53-Logos/01-Social-Medias/SocialMediaFacebook1"));
var _ProfessionalNetworkLinkedin = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/53-Logos/07-Professional-Networks/ProfessionalNetworkLinkedin"));
var _SocialVideoYoutubeClip = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/53-Logos/05-Videos/SocialVideoYoutubeClip"));
var _SocialMediaXing = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/53-Logos/01-Social-Medias/SocialMediaXing"));
var _SocialMediaTwitterX = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/53-Logos/01-Social-Medias/SocialMediaTwitterX"));
var _SocialVideoTiktok = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/53-Logos/05-Videos/SocialVideoTiktok1"));
var _SocialMusicPodcast = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/53-Logos/04-Music/SocialMusicPodcast.js"));
var _SocialMusicSpotify = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/53-Logos/04-Music/SocialMusicSpotify1.js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var icons = {
  facebook: _SocialMediaFacebook.default,
  linkedin: _ProfessionalNetworkLinkedin.default,
  twitter: _SocialMediaTwitterX.default,
  youtube: _SocialVideoYoutubeClip.default,
  instagram: _SocialInstagram.default,
  xing: _SocialMediaXing.default,
  tiktok: _SocialVideoTiktok.default,
  podcast: _SocialMusicPodcast.default,
  spotify: _SocialMusicSpotify.default
};
function SocialLink(_ref) {
  var link = _ref.link;
  return /*#__PURE__*/_react.default.createElement(_Footer.SocialIcon, {
    href: link.href,
    target: "_blank",
    "data-key": "max-footer__social-icons__".concat(link.title),
    "aria-label": "".concat(link.title)
  }, /*#__PURE__*/_react.default.createElement(icons[link.title], {
    size: 'sm',
    title: link.title
  }));
}